import logFactory from '../logger';
var log = logFactory('', {
  displayAllErrors: true
});

export function validateIfOperational(context) {
  if (!context.get(context.constants.DESTROYED, true)) return true;

  log.error('Client has already been destroyed - no calls possible.');
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/utils/inputValidation/isOperational.js
// module id = hLuW
// module chunks = 88